import Box from '@mui/material/Box';
import { FieldProps, FileField, useRecordContext } from 'react-admin';

type DocumentLinkFieldProps = FieldProps & { title?: string; testId?: string };

export const DocumentLinkField = ({
  title = 'document_id',
  source = 'url',
  testId,
}: DocumentLinkFieldProps) => {
  const record = useRecordContext();

  const url = record?.[source];

  if (!url) {
    return null;
  }

  return (
    <Box onClick={(event) => event.stopPropagation()} sx={{ width: 'fit-content' }}>
      <FileField
        data-testid={testId}
        source={source}
        title={title}
        rel="noopener"
        target="_blank"
      />
    </Box>
  );
};
